import { render, staticRenderFns } from "./OrganizationViewOrganizationInfoCard.vue?vue&type=template&id=404716d4"
import script from "./OrganizationViewOrganizationInfoCard.vue?vue&type=script&lang=js"
export * from "./OrganizationViewOrganizationInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports